import axios from "axios";
import { ls } from "../variables";
import { encrypt } from "./cipher";

const checkAuth = async () => {
    try {
        const authToken = ls.get("authToken");
        const refreshToken = ls.get("refreshToken");

        if (!authToken || !refreshToken) {
            console.warn("Missing tokens");
            return false;
        }
        const encrypted = await encrypt({
            authToken,
            refreshToken
        });

        const {data} = await axios.get("/api/pms/get-profile", {
            headers: {
                "headers": (encrypted),
            }
        });

        if (!data) {
            console.error("Server returned error:", data);
            return false;
        }

        return {
            success: data?.success,
            expires: data?.expires
        };

    } catch (error) {
        console.error("Auth check failed:", error);
        ls.removeAll()
        return {
            success: false,
            expires: 0
        };
    }
};

export { checkAuth };
